
import {
  defineComponent, shallowRef, computed, nextTick, reactive, watch, onBeforeMount,
} from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import Loader from '@/components/partials/Loader.vue';

export default defineComponent({
  components: {
    Loader,
  },

  setup() {
    const route = useRoute();
    const store = useStore();
    const slug = computed(() => route.params.pageSlug);
    const show = reactive({ value: false });

    const fetch = () => {
      show.value = false;

      if (route.params.pageSlug) {
        store.dispatch('pages/fetchBySlug', route.params.pageSlug);
      } else {
        store.dispatch('pages/fetchFrontPage');
      }
    };

    onBeforeMount(() => {
      fetch();
    });

    watch(() => slug.value, (newSlug, oldSlug) => {
      if (newSlug !== oldSlug) {
        fetch();
      }
    });

    const page = computed(() => store.getters['pages/page']);
    const status = computed(() => store.getters['pages/status']);
    const pageContent = reactive({
      component: shallowRef(defineComponent({
        template: '<div class="page-content"></div>',
      })),
    });

    const pageType = computed<string>(() => store.getters['pages/pageType']);

    const updateAdminBar = () => {
      const $wpAdminBarCustomizer = document.querySelector('#wp-admin-bar-customize > a');
      const $wpAdminBarEdit = document.querySelector('#wp-admin-bar-edit > a');

      if ($wpAdminBarCustomizer) {
        $wpAdminBarCustomizer.setAttribute('href', `/wp-admin/customize.php?url=${window.location.origin}${route.path}`);
      }

      if ($wpAdminBarEdit) {
        $wpAdminBarEdit.setAttribute('href', `/wp-admin/post.php?post=${page.value.id}&action=edit`);
      }
    };

    const updateMeta = () => {
      const $title = document.querySelector('head title');
      const $description = document.querySelector('head [name="description"]');
      const $keywords = document.querySelector('head [name="keywords"]');

      let title;
      let description;
      let keywords;

      if (page.value) {
        title = page.value.meta.title;
        description = page.value.meta.description;
        keywords = page.value.meta.keywords;
      } else {
        title = '404 - Seite nicht gefunden';
        description = 'Diese Seite konnte nicht gefunden werden';
        keywords = '404';
      }

      if ($title) {
        $title.innerHTML = title;
      }
      if ($description) {
        $description.setAttribute('content', description);
      }
      if ($keywords) {
        $keywords.setAttribute('content', keywords);
      }
    };

    watch(() => status.value, (newStatus) => {
      if (document.scrollingElement) {
        document.scrollingElement.scrollTop = 0;
      }

      if (newStatus === 0) {
        pageContent.component = defineComponent({
          template: `<div class="page-content">${page.value !== null ? page.value.content : '<PageError :error="404"></PageError>'}</div>`,
        });

        nextTick(() => {
          show.value = true;
        });

        const $wpAdminBar = document.querySelector('#wpadminbar');
        if ($wpAdminBar) {
          updateAdminBar();
        }

        updateMeta();

        nextTick(() => {
          nextTick(() => {
            const $klimaheldSection = document.querySelector('#klimaheld-werden');

            if ($klimaheldSection) {
              store.dispatch('pages/setHasKlimaheldSection', true);
            } else {
              store.dispatch('pages/setHasKlimaheldSection', false);
            }
          });
        });
      }
    });

    const closeSidebar = () => {
      store.dispatch('sidebar/close');
    };

    const isLoading = computed(() => status.value === 1);

    return {
      isLoading,
      page,
      pageContent,
      show,
      pageType,
      slug,
      closeSidebar,
    };
  },
});
